"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFilterComponent = createFilterComponent;
exports.updateAccordionVisibility = updateAccordionVisibility;
const etic_1 = require("../services/etic");
function createFilterComponent() {
    const filterContainer = document.createElement('div');
    filterContainer.className = 'filter-container';
    const filters = [
        {
            title: 'Accueil',
            name: 'taux-',
            options: etic_1.SpajService.taux
        },
    ];
    filters.forEach((filter) => {
        const accordion = document.createElement('div');
        accordion.className = 'accordion';
        const accordionHeader = document.createElement('div');
        accordionHeader.className = 'accordion-header';
        accordionHeader.textContent = filter.title;
        const accordionLegend = document.createElement('legend');
        accordionLegend.textContent = filter.title;
        accordionLegend.style.display = 'none';
        accordionHeader.appendChild(accordionLegend);
        accordionHeader.setAttribute('aria-expanded', 'true');
        const span = document.createElement('span');
        span.innerHTML = '<button type="button" aria-label="Afficher/Masquer le contenu" class="filters-icon"><span class="ph text-2xl text-primary-700 ph-plus"></span></button>';
        accordionHeader.appendChild(span);
        const accordionContent = document.createElement('div');
        accordionContent.className = 'accordion-content ';
        accordionContent.role = 'group';
        filter.options.forEach((key, value) => {
            const k = filter.name + value;
            const checkboxContainer = document.createElement('div');
            checkboxContainer.className = 'checkbox-container ' + filter.name;
            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.id = k;
            checkbox.name = value;
            const label = document.createElement('label');
            label.htmlFor = k;
            label.textContent = value + '% ' + key;
            checkboxContainer.appendChild(checkbox);
            checkboxContainer.appendChild(label);
            accordionContent.appendChild(checkboxContainer);
        });
        accordionHeader.addEventListener('click', () => {
            const isExpanded = accordionHeader.getAttribute('aria-expanded') === 'true';
            accordionHeader.setAttribute('aria-expanded', (!isExpanded).toString());
            accordionContent.classList.toggle('hidden');
        });
        accordionHeader.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const isExpanded = accordionHeader.getAttribute('aria-expanded') === 'true';
                accordionHeader.setAttribute('aria-expanded', (!isExpanded).toString());
                accordionContent.classList.toggle('hidden');
            }
        });
        accordion.appendChild(accordionHeader);
        accordion.appendChild(accordionContent);
        let f = document.createElement('fieldset');
        f.appendChild(accordion);
        filterContainer.appendChild(f);
    });
    const filtersElement = document.querySelector('#filters');
    if (filtersElement) {
        filtersElement.appendChild(filterContainer);
    }
    else {
        console.error("Element with id 'filters' not found.");
    }
}
// Function to update accordion visibility based on checkbox state
function updateAccordionVisibility() {
    const accordions = document.querySelectorAll('.accordion');
    accordions.forEach(accordion => {
        const accordionHeader = accordion.querySelector('.accordion-header');
        const accordionContent = accordion.querySelector('.accordion-content');
        if (!accordionContent)
            return;
        const isChecked = Array.from(accordionContent.querySelectorAll('input[type="checkbox"]'))
            .some(checkbox => checkbox.checked);
        accordionHeader?.setAttribute('aria-expanded', isChecked.toString());
        accordionContent.classList.toggle('hidden', !isChecked);
    });
}
